import React, {Fragment} from 'react';
import ReactDOM from 'react-dom';

import classes from './Modal.module.scss';

interface Props {  
  children?: React.ReactNode; 
}

const Backdrop = props => {  
  return <div className={classes.backdrop} />
}

const ModalOverlay: React.FunctionComponent<Props> = props => {
  return (
    <div className={classes.modal}>
      <div className={classes.content}>{props.children}</div>
    </div>
  );
}

const portalElement = document.getElementById('overlays')! ; // ! is needed for typescript

const Modal: React.FunctionComponent<Props> = props => {
  return(
    <Fragment>
      {ReactDOM.createPortal(<Backdrop />, portalElement)}
      {ReactDOM.createPortal(
        <ModalOverlay>{props.children}</ModalOverlay>,
        portalElement
      )}
    </Fragment>
  )
};

export default Modal;